import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { CustomSearchResults, OccSearchBoxSuggestions } from '@search/const';
import { SUGGESTIONS_SOLR_NORMALIZER } from '@search/utils';
import { ConverterService, OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccSearchSuggestionsSolrService {
  constructor(
    private http: HttpClient,
    private occEndpoints: OccEndpointsService,
    private converter: ConverterService,
  ) {}

  loadCustomSuggestions(term: string, pageSize = 5): Observable<CustomSearchResults> {
    return this.http
      .get<OccSearchBoxSuggestions>(this.getSuggestionEndpoint(term, pageSize.toString()), {
        context: new HttpContext().set(
          HTTP_CONTEXT_ENDPOINT,
          this.occEndpoints.getRawEndpointValue('productSuggestions'),
        ),
      })
      .pipe(this.converter.pipeable(SUGGESTIONS_SOLR_NORMALIZER));
  }

  private getSuggestionEndpoint(term: string, max: string): string {
    return this.occEndpoints.buildUrl('productSuggestions', {
      queryParams: { term, max },
    });
  }
}
